import { concat, hash } from '@ember/helper';
import { LinkTo } from '@ember/routing';
import { service } from '@ember/service';
import Component from '@glimmer/component';

import cssTransition from 'ember-css-transitions/modifiers/css-transition';
import { t } from 'ember-intl';
import svgJar from 'ember-svg-jar/helpers/svg-jar';
import EmberPopover from 'ember-tooltips/components/ember-popover';
import { eq, not, or } from 'ember-truth-helpers';

import modelIcon from 'umg-ember-backend/helpers/model-icon';
import recordHeadlineOrNew from 'umg-ember-backend/helpers/record-headline-or-new';
import { getBem } from 'umg-ember-backend/utils/get-bem';
import { getRecordType } from 'umg-ember-backend/utils/get-record-type';

import styles from './styles.module.css';

const bem = getBem(styles);

export default class ApplicationBreadcrumbItemComponent extends Component {
  // Services
  @service breadcrumb;

  // Template
  <template>
    {{#unless @isFirst}}
      {{svgJar 'chevron-right' class='u-icon'}}
    {{/unless}}
    <li
      class={{bem
        (hash
          is-current=(eq @route this.breadcrumb.currentRoute)
          has-changes=@route.hasDirtyModel
        )
      }}
      {{cssTransition
        (bem)
        enterClass=styles.scope--enter
        leaveClass=styles.scope--leave
        enterToClass=styles.scope--enter-to
        leaveToClass=styles.scope--leave-to
        isEnabled=(not @isFirst)
      }}
    >
      {{#if (or @route.model.isNew @route.isExplorerRoute)}}
        <LinkTo
          @route={{@route.routeName}}
          @query={{@route.queryParams}}
          class={{bem 'link'}}
        >
          {{svgJar (modelIcon @route.recordType) class=(bem 'icon')}}
          {{@route.name}}
        </LinkTo>
      {{else}}
        <LinkTo
          @route={{@route.routeName}}
          @model={{@route.model}}
          @query={{@route.queryParams}}
          class={{bem 'link'}}
        >
          {{svgJar (modelIcon @route.recordType) class=(bem 'icon')}}
          {{@route.name}}
        </LinkTo>
      {{/if}}

      {{#if @route.hasDirtyModel}}
        <div class={{bem 'changes'}}></div>
      {{/if}}

      {{#unless @route.isExplorerRoute}}
        <EmberPopover @delay={{800}}>
          <div class={{bem 'popover-overline'}}>
            {{t
              'application.breadcrumb.item.popover_overline'
              recordTypeLabel=(t
                (concat 'models.' (getRecordType @route.model))
              )
              id=@route.model.id
            }}
          </div>
          <div class={{bem 'popover-headline'}}>
            {{recordHeadlineOrNew @route.model}}
          </div>
          {{#if @route.hasDirtyModel}}
            <div class={{bem 'popover-changes'}}>
              {{t 'application.breadcrumb.item.popover_changes'}}
            </div>
          {{/if}}
        </EmberPopover>
      {{/unless}}
    </li>
  </template>
}
